<div>
  <h3>
    You're Done! |
    <app-company-quoteid-header [quote]="quoteRequestState"></app-company-quoteid-header>
  </h3>
  <section class="image-text">
    <section class="image-content">
      <img [src]="outcomeImageSrc" alt="outcomeImage" />
    </section>
    <section class="text-content">
      <h4>{{ title }}</h4>
      <ng-content select="[statement-content]"></ng-content>
      <ng-content select="[rejection-reason-content]"></ng-content>

      <section class="documents" *ngIf="youreDoneData?.attachments?.length > 0 && !hideDocuments">
        <h4>Attachments</h4>
        <p>
          <ng-container *ngFor="let attachment of youreDoneData?.attachments">
            <a [file]="attachment" appDownloadLink>{{ attachment.fileName }}</a
            ><br />
          </ng-container>
        </p>
      </section>
      <!-- Under the attachments header, a hyperlink of each document that has been uploaded throughout the journey will be listed (including Countersigned Offer Documents if they have been uploaded in the previous screen). Hyperlinks will be styled in the same way as other hyperlinks in the system: secondary colour (#EE8E00 orange), underlined, bold.
    This section will only be displayed if a user has uploaded attachments in the previous screen (Upload Countersigned Documents - optional selection) -->

      <ng-content select="[action-buttons]"></ng-content>
    </section>
  </section>
</div>
